import dayjs, { Dayjs } from 'dayjs';
import type { StockInventoryItem } from '../metals';

export interface ContractDateValidationResult {
    maxContract: Dayjs | null;
    errorKey: string | null;
}

/**
 * Pure validator: checks that no contract_date is after the inventory date and returns
 * the maximum contract date across items. Does not perform any UI side effects.
 */
export const validateContractDates = (
    items: StockInventoryItem[],
    inventoryDate: string,
): ContractDateValidationResult => {
    let maxContract: Dayjs | null = null;
    const invDate = dayjs(inventoryDate);

    for (const item of items) {
        if (!item.contract_date) continue;
        const cd = dayjs(item.contract_date);
        if (cd.isAfter(invDate, 'day')) {
            return { maxContract: null, errorKey: 'metals.contractDateAfterInventory' };
        }
        if (!maxContract || cd.isAfter(maxContract)) {
            maxContract = cd;
        }
    }

    return { maxContract, errorKey: null };
};
